import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog and other third-party analytics errors that don't affect the app
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('postMessage') ||
    event.message.includes('PerformanceServerTiming') ||
    event.message.includes('posthog')
  )) {
    event.preventDefault();
    event.stopPropagation();
    console.warn('Suppressed analytics error:', event.message);
    return true;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('postMessage') ||
    event.reason.message.includes('PerformanceServerTiming') ||
    event.reason.message.includes('posthog')
  )) {
    event.preventDefault();
    console.warn('Suppressed analytics promise rejection');
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
